import { Injectable } from '@angular/core';
import { FindAssetPurchasesBuyConfigInterface } from '@app/shared/interfaces/configurations/find-asset-purchases-buy-config.interface';
import { FindAssetPurchasesSellConfigInterface } from '@app/shared/interfaces/configurations/find-asset-purchases-sell-config.interface';
import { FindAssetWithdrawalsConfigInterface } from '@app/shared/interfaces/configurations/find-asset-withdrawals-config.interface';
import { QueryParamsInterface } from '@interfaces/global/query.params.interface';
import { AbstractCrudService } from '../../abstract/abstract-crud.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationsPurchaseService extends AbstractCrudService<
  FindAssetPurchasesBuyConfigInterface,
  QueryParamsInterface
> {
  protected override errorsSection = 'errors.configurations';
  protected override endPoint = '/configurations/assets/%s/purchases/buy';
}

@Injectable({
  providedIn: 'root',
})
export class ConfigurationsSellService extends AbstractCrudService<
  FindAssetPurchasesSellConfigInterface,
  QueryParamsInterface
> {
  protected override errorsSection = 'errors.configurations';
  protected override endPoint = '/configurations/assets/%s/purchases/sell';
}

@Injectable({
  providedIn: 'root',
})
export class ConfigurationsWithdrawalService extends AbstractCrudService<
  FindAssetWithdrawalsConfigInterface,
  QueryParamsInterface
> {
  protected override errorsSection = 'errors.configurations';
  protected override endPoint = '/configurations/assets/%s/withdrawals';
}
